var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.Abierto)?_c('v-alert',{staticStyle:{"min-width":"200px"},attrs:{"type":_vm.Tipo,"transition":"slide-y-reverse-transition"}},[_vm._v(_vm._s(_vm.Mensaje))]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }